
import Vue, { PropType } from 'vue'
import JFileContainer from '@/models/JFileContainer'

export default Vue.extend({
  props: {
    value: Object as PropType<JFileContainer>,
  },
  data: () => ({
    fileReader: new FileReader(),
    preview: undefined as string | ArrayBuffer | null | undefined,
  }),
  watch: {
    'value.file': {
      immediate: true,
      handler(newVal) {
        if (!newVal) this.preview = undefined

        this.fileReader.readAsDataURL(this.value.file) // convert to base64 string
      },
    },
  },
  created() {
    // set FileReader.onLoad listener
    this.fileReader.onload = this.onFileReaderLoad
  },
  methods: {
    onFileReaderLoad(e: ProgressEvent<FileReader>) {
      this.preview = e?.target?.result
    },
  },
})
